import React from 'react';
import Layout from '../components/Layout/Layout';

const rules = [
  "The last date of submission of application forms will be displayed on the notice board of the college.",
  "The selected candidates will have to pay all fees within the prescribed date. In case a student does not deposit fees by that date, his/her admission will be treated as cancelled.",
  "Students who cancel admission at any time for any reason shall have to pay tuition fees & other fees as per university rules.",
  "No certificate of any kind will be issued unless full session fees are paid. Any amount paid by the student at the time of admission and later will not be refunded.",
  "All new entrants will have to enroll themselves in the university. A prescribed form for this purpose will be supplied by the college in due course of time or on the date prescribed by the university.",
  "Students who fail to fill in the form shall be responsible for any action taken by appropriate authorities.",
  "Students shall have to obey all the instructions of the Principal. They will be answerable to him for their behavior in general, both inside and outside the college.",
  "Students found violating the rules of the college administration or behaving in an indiscipline manner will be expelled from the college. It will be presumed on admission that the students concerned and their parents and/ or guardians have read and concurred with these rules.",
  "Students should behave respectfully with all staff members at college and politely with their fellow students, including girls. Any act of disobedience, improper and discourteous exchange of words or indecent remarks, especially at girl students, is a punishable offence and will be viewed seriously.",
  "Students should make careful use of college books, room furniture, fans, laboratory equipment and college property in general. The cost of damage done to it would be recoverable from students either individually or collectively as the case may be.",
  "Only special notices shall be read out in the classroom, Students, therefore, should see the notice board daily and keep themselves well informed about the various notices that may be put up there from time to time.",
  "No student shall send any information concerning the college for publication either to the press or elsewhere without prior approval of the Principal of the college, nor shall he/she approach the President or the L.M.C. Members except through the college Principal. Any breach of this rule may lead to outright expulsion of the student from the college.",
  "The students should not roam in corridors, or play during working hours or free classes, Instead, they should utilize the library and reading room facilities.",
  "Smoking, Gutka / Paan chewing and ragging are strictly prohibited. Offenders are liable to face legal action.",
  "Students are prohibited from forming associations / organizations and from, holding functions in the college without the prior permission of the Principal.",
  "Students are prohibited from organizing welcome and farewell and other such function outside college premises. Violation shall attract severe disciplinary action.",
  "Any change of address must be notified to the college office immediately.",
  "For details of the curriculum refer to the syllabus of the Education Board/University, as the case may be.",
  "The students carry the responsibility of maintaining cleanliness on the campus. Dust bins have been provided at suitable places for this purpose. Any one found littering the college premises or spitting on the wall or causing any dirtiness will be severely penalized.",
  "Use / Possession of cell phone (mobile) in the College Campus is strictly prohibited for students as per law. Student possessing cell phone in College Campus will be punished as per the Rule.",
  "The Principal's decision in all matters relating to admission, administration and enforcement or discipline and general ruled and special instructions mentioned in this prospectus shall be FINAL & BINDING ON ALL."
];

const RulesRegulationsPage = () => {
  return (
    <Layout>
      <div className="page-container" style={{ margin: '40px auto', padding: '0 20px', maxWidth: '1000px' }}>
        
        <div style={{ 
          backgroundColor: '#fafafa', 
          borderRadius: '4px', 
          boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
          padding: '40px 50px',
          borderLeft: '5px solid #0056b3'
        }}>
          <h2 style={{ 
            color: '#004d80', 
            textAlign: 'center', 
            fontSize: '2rem', 
            fontWeight: 'bold',
            marginBottom: '15px' 
          }}>
            Rules & Regulations
          </h2>
          <div style={{ 
            height: '2px', 
            backgroundColor: '#b3d7ff', 
            width: '100%', 
            marginBottom: '40px' 
          }}></div>

          <ol style={{ 
            color: '#444', 
            lineHeight: '1.8', 
            fontSize: '0.85rem',
            paddingLeft: '20px',
            margin: '0'
          }}>
            {rules.map((rule, index) => (
              <li key={index} style={{ marginBottom: '18px', textAlign: 'justify' }}>
                {rule}
              </li>
            ))}
          </ol>
        </div>

      </div>
    </Layout>
  );
};

export default RulesRegulationsPage;
